import React,{useEffect} from "react";
import { useParams } from 'react-router-dom';
import Questionnaire from "../../../Questionnaire/Questionnaire";
import "./SubscriptionRenewQuestionnaire.css";
import * as http from "../../../../utils/http";
import * as translator from "../../../../utils/translator"


const SubscriptionRenewQuestionnaire = ({
  setHidePastQuestionnaire,
  setRefreshData,
  setCurrentGlobalModalName, 
  allSubscriptionData,
  language,
  country,
  orientForSpecificComponent,
  setChangeMedicationModalContent,
  setShowUpdateQuestionnaire,
  showUpdateQuestionnaire,
  invokeOnSubmit,
  setInvokeOnSubmit
}:any) => {

  const {order_hash_id} = useParams();
  const modalClass:string = `renew-questionnaire-message ${orientForSpecificComponent}`

  const onSubmit = (wasRefilled:boolean, questionnaire?:any, files?:any) =>{
    http
      .postToServer(`account-update/subscription/questionnaire`,
      {
        wasRefilled,
        hashID: order_hash_id,
        questionnaire,
        files
      },
      [http.MIDDLEWARES.CUSTOMER_ID]
      )
      .then((response) => {
        setShowUpdateQuestionnaire(false)
        if(setHidePastQuestionnaire){
          setHidePastQuestionnaire(false);
        }
        if(orientForSpecificComponent == 'change-medication'){
          setChangeMedicationModalContent('choose treatment')
        }else{
          setCurrentGlobalModalName("THANKS_FOR_UPDATE");
        }
        setRefreshData((current:boolean) => !current)
      })
      .catch((error) => {

      })
      .finally(()=> {
        
      })
  }

  useEffect(() => {
    if(setHidePastQuestionnaire){
      setHidePastQuestionnaire(true)
    }
    if(invokeOnSubmit){
      onSubmit(false)
      setInvokeOnSubmit(false)
    }
  }, [invokeOnSubmit])
  
  
  if(order_hash_id){
    const subscriptionData = allSubscriptionData;
    const today = new Date()
    const wasFilledAt = new Date(subscriptionData.wasFilledAt);
    const monthsDifference = (today.getFullYear() - wasFilledAt.getFullYear()) * 12 + (today.getMonth() - wasFilledAt.getMonth());
    
    return (
      <div className={orientForSpecificComponent == 'change-medication' ? "renew-questionnaire-container height-limit" : "renew-questionnaire-container"}>
        {!showUpdateQuestionnaire && (
          <div className={modalClass}>
            {orientForSpecificComponent == 'change-medication' ? (
              <>
              <p>
                <strong>
                  {translator.translate(language, "my_account", "SubscriptionOrders/changeMedicationModal/change_medication_modal_title")}
                </strong>
              </p>
              <p>
                {translator.translate(language, "my_account", "SubscriptionOrders/changeMedicationModal/change_medication_modal_text")}
              </p>
              </>
            )
            :
            (
              <>
              <p>
                <strong>
                  {translator.translate(language, "my_account", 'SubscriptionOrders/changeMedicationModal/subscription_renew_questionnaire_title')}
                </strong>
              </p>
              <p>
                {translator.translate(language, "my_account", 'SubscriptionOrders/changeMedicationModal/subscription_renew_questionnaire_text')}
              </p>
              <p>
                {translator.translate(language, "my_account", 'SubscriptionOrders/changeMedicationModal/subscription_renew_questionnaire_text_2')}
              </p>
              <p>
                <strong>
                  {translator.translate(language, "my_account", 'SubscriptionOrders/changeMedicationModal/subscription_renew_questionnaire_text_3').replace(":monthsDifference", monthsDifference.toString())}
                </strong>
              </p>
              </>
            )
            }

            <div className="buttons-container">
              <div className="buttons-inner-container">
                <div 
                  className="renew-questionnaire-button const-width"
                  onClick={()=> {
                    if(setHidePastQuestionnaire){
                      setHidePastQuestionnaire(true);
                    }
                    setShowUpdateQuestionnaire(true);
                  }}
                 >
                  {translator.translate(language, "my_account", "SubscriptionOrders/changeMedicationModal/change_medication_button_confirm")}
                </div>
                <div 
                  className="renew-questionnaire-button const-width"
                  onClick={()=> {onSubmit(false);}}
                >
                  {translator.translate(language, "my_account", "SubscriptionOrders/changeMedicationModal/change_medication_button_cancel")}
                </div>
              </div>
              {
              orientForSpecificComponent != 'change-medication' && //dont display btn for display old q-re for change medication
              <div className="renew-questionnaire-show-last-questionnaire" onClick={()=> {setHidePastQuestionnaire(false); setShowUpdateQuestionnaire(false)}}>Meinen letzten medizinischen Fragebogen ansehen</div>
              }
            </div>
          </div>
        )}

        {
          showUpdateQuestionnaire ? 
          <Questionnaire 
          submitButtonText = {'Fragebogen aktualisieren'}
          overrideQuestionnaireParams={{            
            language,
            country,
            optionalCategory: subscriptionData.catalog_mention
          }}
          onSubmitOverride={onSubmit}
          disableSkipQuestionnaireModal={true}
          hideHeaderAndLogin={true}
          />
          :
          null
        }
      </div>
    );
  } else {
    return (<> </>)
  }
};

export default SubscriptionRenewQuestionnaire;
